/**
 * "Ana or Ben (covering for Ana)" from waitingFor: [{ id, name, coveringFor? }].
 * coveringFor = the employee id of an approver on leave that this person covers
 * (the next branch manager up); the one on leave can still act too.
 */
export const waitingNames = (list = []) =>
  (list || [])
    .map((w) => {
      if (!w.coveringFor) return w.name;
      const forName = list.find((x) => x.id === w.coveringFor)?.name;
      return forName
        ? `${w.name} (covering for ${forName})`
        : `${w.name} (covering)`;
    })
    .join(" or ");

/**
 * One-step approvals: everyone named decides together, first decision is
 * final. "Ana or Ben, or a manager above / HR"; with nobody named,
 * "A branch manager above or HR".
 */
export const approverGroupText = (list, managersAbove) => {
  const names = waitingNames(list);
  if (!names) return managersAbove ? "A branch manager above or HR" : "";
  return managersAbove ? `${names}, or a manager above / HR` : names;
};
